import { EventEmitter, Injectable, Output } from "@angular/core";
import {
  NavController,
  ModalController,
  AlertController,
  ToastController,
  LoadingController,
  Platform,
} from "@ionic/angular";
import { environment } from "src/environments/environment";
import { Dialogs } from "@ionic-native/dialogs/ngx";

@Injectable({
  providedIn: "root",
})
export class UxService {
  loading: HTMLIonLoadingElement;

  @Output() onSalirAlertDimissed = new EventEmitter<boolean>();

  constructor(
    private loadingController: LoadingController,
    private toastCtrl: ToastController,
    private alertCtrl: AlertController,
    private modalController: ModalController,
    private navCtrl: NavController,
    private dialogs: Dialogs,
    protected platform: Platform
  ) {}

  async showCargando(message?: string) {
    this.loading = await this.loadingController.create({
      message: message || "Cargando",
      spinner: "crescent",
      translucent: true,
      cssClass: "app-loading",
    });

    this.loading.dismiss();

    await this.loading.present();
  }

  hideCargando() {
    if (this.loading) {
      this.loading.dismiss();
      this.loading = undefined;
    }
  }

  async showError(error) {
    console.error(error);
    await this.showToast("Error", error.message, "alert-danger");
  }

  async showToast(
    header: string,
    mensaje: string,
    color: string,
    duration?: number,
    position?: "top" | "bottom"
  ) {
    const toast = await this.toastCtrl.create({
      header: header,
      message: mensaje,
      color: color,
      position: position || "top",
      duration: duration || 10000,
      buttons: [
        {
          text: "Ok",
          role: "cancel",
          handler: () => {},
        },
      ],
    });

    this.toastCtrl.dismiss(() => {
      console.log("Dismissed toast");
    });

    toast.present();
  }
}
